import { z } from 'src/lib'
import { getEndpoint } from '.'
import { schemaEntityWithId } from 'src/types'
import { OperacionWRCFields } from '../types/fields'
import { HttpAxiosRequest } from 'src/http/httpAxiosBase'

const schema = z
    .object({
        [OperacionWRCFields.CodOperacion]: z.number(),
        [OperacionWRCFields.CodPais]: z.number(),
        [OperacionWRCFields.CodSectorComercial]: z.number(),
        [OperacionWRCFields.DenominacionComitente]: z.string(),
        [OperacionWRCFields.FechaAlta]: z.coerce.date().nullable(),

        // .transform(date => new Date(date)),
        [OperacionWRCFields.FechaEmision]: z.coerce.date(),

        // .transform(date => new Date(date)),
        [OperacionWRCFields.FechaVencimiento]: z.coerce.date(),

        // .transform(date => new Date(date)),
        [OperacionWRCFields.IdUsuarioAlta]: z.number(),
        [OperacionWRCFields.NombreUsuarioAlta]: z.string(),
        [OperacionWRCFields.ApellidoUsuarioAlta]: z.string(),
        [OperacionWRCFields.MailUsuarioAlta]: z.string(),
        [OperacionWRCFields.NombrePais]: z.string(),
        [OperacionWRCFields.NombreSectorComercial]: z.string(),
        [OperacionWRCFields.NroComitente]: z.string(),
        [OperacionWRCFields.Observaciones]: z.string().optional(),
        [OperacionWRCFields.PermiteEditar]: z.boolean(),
        [OperacionWRCFields.PermiteEliminar]: z.boolean()
    })
    .merge(schemaEntityWithId)

export type OperacionWRC = z.infer<typeof schema>

export const get = (idOperacion: number): Promise<OperacionWRC> => {
    const endpoint = getEndpoint(`${idOperacion}`)

    return HttpAxiosRequest.get(endpoint)
        .then(response => {
            const parsed = schema.safeParse(response)

            if (!parsed.success) {
                console.error('Error de validación:', parsed.error.issues)

                return Promise.reject(new Error('Error de validación.'))
            }

            return parsed.data
        })
        .catch(error => {
            console.error('Error de red:', error)

            return Promise.reject('Error de red.')
        })
}
